<template>
  <layout-auth style="background-color: #f3f5f7 !important">
    <v-form>
      <v-container class="py-8">
        <v-row>
          <v-col>
            <h1 class="text-h4 font-weight-light py-5">
              {{ $t("supplierData.personalDataConfirmation") }}
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("supplierData.userData") }}
            </h2>
            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("supplierData.editUserData3") }}
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label class="second-type-label">{{ $t("supplierData.usernameCompany") }}</label>
            <p>{{ changeNombreUsuario }}</p>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label class="second-type-label">{{ $t("supplierData.nifcif") }}</label>
            <p>{{ changeNif }}</p>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label class="second-type-label">{{ $t("supplierData.clientePagador") }}</label>
            <p>{{ clientePagador.name }}</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <label class="second-type-label">{{ $t("supplierData.address") }}</label>
            <p>{{ changeAddress }}</p>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label class="second-type-label">{{ $t("supplierData.postalCode") }}</label>
            <p>{{ changePostalCode }}</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label class="second-type-label">{{ $t("supplierData.city") }}</label>
            <p>{{ changeLocation }}</p>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label class="second-type-label">{{ $t("supplierData.state") }}</label>
            <p>{{ changeProvince }}</p>
          </v-col>
        </v-row>
        <v-row class="pb-10">
          <v-col cols="12" sm="12" md="6" lg="3">
            <label class="second-type-label">{{ $t("supplierData.phone") }}</label>
            <p>{{ changePhone }}</p>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label class="second-type-label">{{ $t("supplierData.fax") }}</label>
            <p>{{ changeFax }}</p>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label class="second-type-label">{{ $t("supplierData.notificationEmail") }}</label>
            <p>{{ changeEmail }}</p>
          </v-col>
        </v-row>

        <v-row class="pb-10">
          <v-col cols="12" sm="12">
            <h2 class="text-h5 font-weight-light" v-if="!hiddenCheck">
              {{ $t("supplierData.acceptTermsTitle") }}
            </h2>
          </v-col>
          <v-col cols="12" sm="12">
              <checkbox-terms :checkboxData="entityConfig.checkboxDatosProveedores" @accepted="checkbox = true" @canceled="checkbox = false" />
          </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              v-if="!confirmed"
              @click="confirm_edit_provedor"
              :disabled="!checkbox"
              depressed
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.confirm") }}
            </v-btn>
            <v-btn
              v-else
              depressed
              @click="finalizar"
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.finish") }}
            </v-btn>
            <v-btn
              v-if="!confirmed"
              outlined
              @click="volver"
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.goBack") }}
            </v-btn>
            <v-btn v-else plain :color="entityConfig.primaryColor" @click="print" class="float-end m-2 v-btn-width-default">
              <v-icon left> mdi-printer-outline </v-icon>
              {{ $t("supplierData.print") }}
            </v-btn>
          </v-col>
          <v-col></v-col>
        </v-row>
        <overlay :visible="spinner" :opacity="1"></overlay>
      </v-container>
    </v-form>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import { mapState } from "vuex";
import Overlay from "../../components/layouts/overlay.vue";
import CheckboxTerms from "../../components/layouts/checkbox-terms.vue";
import Api from "../../Services/index";

export default {
  components: {
    'layout-auth': LayoutAuth,
    "checkbox-terms": CheckboxTerms,
    Overlay,
  },
  data: () => ({
    hiddenCheck: false,
    spinner: false,
    confirmed: false,
    entityConfig: {},
    checkbox: false,
    model: {
      clientName: "",
      nifcif: "",
      usernameCompany: "",
      address: "",
      postalCode: "",
      city: "",
      state: "",
      phone: "",
      fax: "",
      notificationEmail: "",
    },
  }),

  computed: {
    ...mapState("management", [
      "clientePagador",
      "nombreUsuario",
      "changeNombreUsuario",
      "changeNif",
      "changeAddress",
      "changePostalCode",
      "changeProvince",
      "changePhone",
      "changeFax",
      "changeEmail",
      "changeLocation",
    ]),
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    this.hiddenCheck = this.entityConfig.checkboxDatosProveedores?.type == 'hidden';
  },
  methods: {
    print() {
       window.print();
    },
    volver() {
      this.$router.push("/gestion-de-proveedores");
    },

    async confirm_edit_provedor() {
      try {
        this.spinner = true;
        this.userdata = JSON.parse(sessionStorage.getItem("userData"));
        this.userId = this.userdata.supplierId.trim();
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        const formData = new FormData();
        formData.append("address", this.changeAddress);
        formData.append("email", this.changeEmail);
        formData.append("fax", this.changeFax);
        formData.append("name", this.clientePagador.name);
        formData.append("location", this.changeLocation);
        formData.append("phone", this.changePhone);
        formData.append("postalCode", this.changePostalCode);
        formData.append("province", this.changeProvince);
        formData.append("numClient", this.clientePagador.numClient);
        formData.append("supplierId", this.userId);
        const obj = Object.fromEntries(formData);
        await Api.patch(`/proveedores/${this.userId}`, obj);


        this.$toast.success("Proveedor Modificado");
        this.confirmed = true;
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },
    finalizar() {
        this.$store.commit("management/clientePagador", "");
        this.$store.commit("management/changeNombreUsuario", "");
        this.$store.commit("management/changeNif", "");
        this.$store.commit("management/changeAddress", "");
        this.$store.commit("management/changePostalCode", "");
        this.$store.commit("management/changeProvince", "");
        this.$store.commit("management/changePhone", "");
        this.$store.commit("management/changeLocation", "");
        this.$store.commit("management/changeFax", "");
        this.$store.commit("management/changeEmail", "");
        this.$store.commit("management/changeNombreUsuario", "");
      this.$router.push("/gestion-de-proveedores");
    },
  },
};
</script>
